import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import './HorizontalLineWithTitle.css'

const Divider = ({title = ''}) => {
  return (
    <Container className="my-2">
      <Row className="align-items-center">
        <Col xs="3">
          <hr />
        </Col>
        <Col xs="6" className="text-center">
          <span className="line-title">{title}</span>
        </Col>
        <Col xs="3">
          <hr />
        </Col>
      </Row>
    </Container>
  )
}

export default Divider
